import useBudgetingService, {
  BUDGETING_CREATE_STRUCTURE,
} from 'domain/organization/serviceCatalog/budgets/budgetingService';
import { Show } from 'framework/show';
import ServiceCostsStructureEntityHeader from 'domain/organization/serviceCatalog/budgets/structure/ServiceCostsStructureEntityHeader';
import { useServiceCatalogId } from 'domain/organization/serviceCatalog/useServiceCatalogId';
import { useServiceCatalogService } from 'domain/shared/serviceCatalog';
import ViewServiceCatalogPageMenu from 'domain/organization/serviceCatalog/Show/ViewServiceCatalogPageMenu';
import ViewServiceCostsStructureBreadcrumbs from 'domain/organization/serviceCatalog/budgets/structure/Show/ViewServiceCostsStructureBreadcrumbs';
import { TimelinePageLayout, TimelineLayout, Timeline } from 'framework/ui/timeline';
import useServiceCostsStructureRegistry from '../serviceBudgetStructureRegistry';
import { useAuthorization } from 'framework/authorization';

const ViewServiceCostsStructure = () => {
  const id = useServiceCatalogId();
  const { getById } = useServiceCatalogService();
  const { searchStructure } = useBudgetingService();
  const { isGranted } = useAuthorization();

  const budgetStructureRegistry = useServiceCostsStructureRegistry();

  return (
    <Show getDataMethod={() => getById(id)}>
      <Timeline registries={[budgetStructureRegistry] as any} getDataMethod={async req => searchStructure(id, req)}>
        <TimelinePageLayout
          title="Costs structure"
          titleVariant="h4"
          hasAddForm={isGranted(BUDGETING_CREATE_STRUCTURE)}
          breadcrumbs={<ViewServiceCostsStructureBreadcrumbs />}
          entityHeader={<ServiceCostsStructureEntityHeader />}
          menu={<ViewServiceCatalogPageMenu />}
        >
          <TimelineLayout noEntriesMessage="No entries in this costs structure yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default ViewServiceCostsStructure;
